import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
// import * as Chartist from 'chartist';
import { WeightHistoryData } from '../../histories/weight-history/weight-history.component';
import { BackOffServiceService } from '../../services/back-off-service.service';
import { environment } from 'src/environments/environment';
import { LogsData } from '../../model/LogsData';
import * as Parse from 'parse';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { Chart } from 'chart.js';
import { map } from 'rxjs/operators';
// import { MatButton } from '@angular/material';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from '../../alert-component';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { QuizData } from '../../questionaire/QuizData';

declare var $: any;

@Component({
  selector: 'app-weight-trend',
  templateUrl: './weight-trend.component.html',
  styleUrls: ['./weight-trend.component.css']
})

export class WeightTrendComponent implements OnInit {
  coachFeedbackForm : FormGroup;
  
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  data: LogsData[];
  canvas: any;
  ctx: any;
  @ViewChild('mychart') mychart;

  buttonColor = ["primary", "default", "primary", "primary", "primary", "default", "primary"]
  buttonMessage = ["unlogged", "", "unlogged", "unlogged", "unlogged", "", "unlogged"]
  BMI = 20;
  Weight2Lose = '0';
  Weight2Update = '0';
  weightGoal = 0;
  weightStack = [0, 0, 0, 0, 0, 0, 0];
  weightStack2 = [0, 0, 0, 0, 0, 0, 0, 0];
  weightStack3 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  myChart: Chart;
  Weightlabels = Last7Days().reverse()
  Weightlabels2 = Last7Weeks().reverse()
  Weightlabels3 = ['', '', '', '', '', '', '', '', '', '', '', '']
  limit_line = [0, 0, 0, 0, 0, 0, 0];
  limit_line2 = [0, 0, 0, 0, 0, 0, 0, 0];
  limit_line3 = [];
  prevM = "";
  index = -1




  topLabel = "past week of weight data"

  weekColor = true;
  monthColor = false;
  allColor = false;

  constructor(
    private _bkoffService: BackOffServiceService, private breakpointObserver: BreakpointObserver,
    private router: Router,
    private cookie: CookieService,
    private formBuilder : FormBuilder,
    private modalService: NgbModal,
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }
  ngOnInit() {
    this.coachFeedbackForm = this.formBuilder.group({
      weekly_log: ['', Validators.required],
      positives_negatives: ['', Validators.required],
      specific_suggestion: ['', Validators.required],
    })
  }

  get fmBuilder() { return this.coachFeedbackForm.controls; }
  getFormControl(name:any) {
    return this.coachFeedbackForm.get(name);
  }
  reset(){
    this.coachFeedbackForm.reset({PersonalData: new QuizData()});
  }
  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.coachFeedbackForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.coachFeedbackForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  submitFeedbackForm(){
    const result: QuizData = Object.assign({}, this.coachFeedbackForm.value); 
    if (this.coachFeedbackForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      return;
    }

    const signUpData = this.coachFeedbackForm;
     console.log(String(signUpData.get(['weekly_log']).value));
     console.log(String(signUpData.get(['positives_negatives']).value));
     console.log(String(signUpData.get(['specific_suggestion']).value));
     
      var userInfo = new QuizData()
      userInfo.weekly_log = String(signUpData.get(['weekly_log']).value)
      userInfo.positives_negatives = String(signUpData.get(['positives_negatives']).value)
      userInfo.specific_suggestion = String(signUpData.get(['specific_suggestion']).value)
      this._bkoffService.setCoachFeedbackDataWeight(userInfo);
      const modalRef = this.modalService.open(NgbdModalContent);
      this.closeFeedbackForm();
      signUpData.setValue({['positives_negatives']: null, ['specific_suggestion']: null, ['weekly_log']: null});
      modalRef.componentInstance.name = "Patient's weight feedback saved";
      modalRef.componentInstance.title = 'Success';
  };

  ngAfterViewInit() {
    this.canvas = this.mychart.nativeElement;
    this.ctx = this.canvas.getContext('2d');
    const patientID = this.cookie.get("patientID");
    var checkCoach = this.cookie.get('coach');


    if (checkCoach === 'true'){
      this._bkoffService.getCurrentBMICoach().then((res) => {
        this.BMI = res;
      })
  
      this._bkoffService.getWeightGoalCoach().then((res) => {
        console.log("res is " + res);
        this.weightGoal = res;
        for (var i = 0; i < this.limit_line2.length; i++) {
          this.limit_line2[i] = res;
        }
        console.log("label 1=" + this.Weightlabels[0])
        var WEIGHT_DATA: WeightHistoryData[] = [];
        var weightBottom = [0, 0, 0, 0, 0, 0, 0];
        var viewedDates = [];
        const today = new Date().getTime();
        console.log("today: " + today);
        var indexDay = today;
        var index = this.weightStack.length - 1;
        this._bkoffService.getWeightHistoryCoach().then((res) => {
          this.data = res;
          this.data.forEach(element => {
            var d = this.getDay(element.weightDate);
            var m = this.getMonth(element.weightDate);
            var y = this.getYear(element.weightDate);
            console.log("month: " + m)
            var day = new Date(m + " " + d + ", " + y + " 00:00:00").getTime();
            if (!viewedDates.includes(this.getDay(element.weightDate))) {
              viewedDates.push(this.getDay(element.weightDate));
              if (!(day < today - 604800000)) {
                const diff = Math.floor((indexDay - day) / 86400000);
                // console.log("month: "+m);
                indexDay = day;
                if (index >= 0) {
                  index -= diff;
                  this.weightStack[index] = parseInt(element.weight);
                  // console.log('index' + index);
                  // console.log("adding weight: " + element.weight + " and adding date: " + element.weightDate);
                  // i -= 1;
                }
              }
            }
            //weekly
            var index2 = this.weightStack2.length - 1;
            if (!(day < today - 5184000000)) {
              const diff = Math.floor((today - day) / 604800000);
              console.log("diff: " + diff)
              if (index2 >= 0) {
                index2 -= diff;
                this.weightStack2[index2] = parseInt(element.weight);
              }
            }
            //all time
            console.log("Previous month: " + this.prevM + "   current month: " + m)
            if (m != this.prevM) {
              // console.log("entered month-----" + m)
              this.prevM = m;
              this.index++;
              if (this.weightStack3[this.index] == 0) {
                this.weightStack3[this.index] = parseInt(element.weight);
                this.Weightlabels3[this.index] = m;
              }
            }
  
  
            // WEIGHT_DATA.push({weight: element.weight, date: element.weightDate});
          });
          //finding weight to lose
          var currWeight = 0;
          var updatedays = -1;
          for (i = 0; i < this.weightStack.length; i++) {
            var weightVal = this.weightStack[i]
            if (weightVal != 0) {
              currWeight = weightVal;
              updatedays = i;
            }
          }
          if (updatedays == -1) {
            this.Weight2Update = "weight data out-of-date";
            this.Weight2Lose = "N/A"
          }
          else if (updatedays == 0) {
            this.Weight2Lose = Math.max(0, currWeight - this.weightGoal).toString();
            this.Weight2Update = "Updated today"
          }
          else if (updatedays == 1) {
            this.Weight2Lose = Math.max(0, currWeight - this.weightGoal).toString();
            this.Weight2Update = "Updated yesturday"
          }
          else {
            this.Weight2Lose = Math.max(0, currWeight - this.weightGoal).toString();
            this.Weight2Update = "Updated " + updatedays + " days ago"
          }
          console.log("weight stak is val " + this.weightStack)
          let axisMin = Math.min((this.weightGoal - 20), minWeight(this.weightStack) - 20)
          if (axisMin < 0) {
            axisMin = 0;
          }
  
          for (var i = 0; i < this.weightStack.length; i++) {
            if (this.weightStack[i] != 0) {
              this.weightStack[i] -= axisMin;
            }
          }
          for (var i = 0; i < this.weightStack2.length; i++) {
            if (this.weightStack2[i] != 0) {
              this.weightStack2[i] -= axisMin;
            }
          }
          while (this.weightStack3[this.weightStack3.length - 1] == 0) {
            this.weightStack3.pop()
            this.Weightlabels3.pop()
          }
          this.weightStack3 = this.weightStack3.reverse()
          this.Weightlabels3 = this.Weightlabels3.reverse()
  
          for (var i = 0; i < this.weightStack3.length; i++) {
            if (this.weightStack3[i] != 0) {
              this.weightStack3[i] -= axisMin;
            }
          }
  
          for (var i = 0; i < this.weightStack3.length; i++) {
            this.limit_line3.push(this.weightGoal - axisMin)
          }
          for (var i = 0; i < this.Weightlabels.length; i++) {
            this.limit_line[i] = this.weightGoal - axisMin;
          }
          for (var i = 0; i < this.Weightlabels2.length; i++) {
            this.limit_line2[i] = this.weightGoal - axisMin;
          }
          this.myChart = new Chart(this.ctx, {
            type: 'bar',
            data: {
              labels: this.Weightlabels,
              datasets: [{
                label: "goal",
                type: "line",
                borderColor: "rgb(255, 134, 78)",
                backgroundColor: "rgb(255, 134, 78)",
                data: this.limit_line,
                fill: false,
                borderWidth: 4,
              },
              {
                label: "weight-line",
                type: "line",
                borderColor: "rgba(52, 152, 219, 0.6)",
                backgroundColor: "rgba(52, 152, 219,0.4)",
                data: [],
                fill: false,
                borderWidth: 4,
              }
  
                , {
                label: "weight-bar",
                type: "bar",
                // borderColor: "#FFC300",
                // backgroundColor: "rgba(247, 220, 111,0.6)",
                backgroundColor: "rgba(52, 152, 219,0.4)",
                backgroundColorHover: "#3e95cd",
                data: this.weightStack
              }
              ]
            },
            options: {
              title: {
                display: false,
                text: ''
              },
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
  
                    if (label) {
                      label += ': ';
                    }
                    label += tooltipItem.yLabel + axisMin;
                    return label;
                  }
                }
              },
              scales: {
                xAxes: [{
                  stacked: false,
                  barPercentage: 0.6
                }],
                yAxes: [{
                  stacked: false,
                  ticks: {
                    suggestedMin: axisMin,
                    callback: function (value, index, values) {
                      return axisMin + value;
                    }
                  }
                }]
              },
              legend: { display: true }
            }
          });
        });
      });

    }else{
      this._bkoffService.getCurrentBMI().then((res) => {
        this.BMI = res;
      })
  
      this._bkoffService.getWeightGoal().then((res) => {
        console.log("res is " + res);
        this.weightGoal = res;
        for (var i = 0; i < this.limit_line2.length; i++) {
          this.limit_line2[i] = res;
        }
        console.log("label 1=" + this.Weightlabels[0])
        var WEIGHT_DATA: WeightHistoryData[] = [];
        var weightBottom = [0, 0, 0, 0, 0, 0, 0];
        var viewedDates = [];
        const today = new Date().getTime();
        console.log("today: " + today);
        var indexDay = today;
        var index = this.weightStack.length - 1;
        this._bkoffService.getWeightHistory().then((res) => {
          this.data = res;
          this.data.forEach(element => {
            var d = this.getDay(element.weightDate);
            var m = this.getMonth(element.weightDate);
            var y = this.getYear(element.weightDate);
            console.log("month: " + m)
            var day = new Date(m + " " + d + ", " + y + " 00:00:00").getTime();
            if (!viewedDates.includes(this.getDay(element.weightDate))) {
              viewedDates.push(this.getDay(element.weightDate));
              if (!(day < today - 604800000)) {
                const diff = Math.floor((indexDay - day) / 86400000);
                // console.log("month: "+m);
                indexDay = day;
                if (index >= 0) {
                  index -= diff;
                  this.weightStack[index] = parseInt(element.weight);
                  // console.log('index' + index);
                  // console.log("adding weight: " + element.weight + " and adding date: " + element.weightDate);
                  // i -= 1;
                }
              }
            }
            //weekly
            var index2 = this.weightStack2.length - 1;
            if (!(day < today - 5184000000)) {
              const diff = Math.floor((today - day) / 604800000);
              console.log("diff: " + diff)
              if (index2 >= 0) {
                index2 -= diff;
                this.weightStack2[index2] = parseInt(element.weight);
              }
            }
            //all time
            console.log("Previous month: " + this.prevM + "   current month: " + m)
            if (m != this.prevM) {
              // console.log("entered month-----" + m)
              this.prevM = m;
              this.index++;
              if (this.weightStack3[this.index] == 0) {
                this.weightStack3[this.index] = parseInt(element.weight);
                this.Weightlabels3[this.index] = m;
              }
            }
  
  
            // WEIGHT_DATA.push({weight: element.weight, date: element.weightDate});
          });
          //finding weight to lose
          var currWeight = 0;
          var updatedays = -1;
          for (i = 0; i < this.weightStack.length; i++) {
            var weightVal = this.weightStack[i]
            if (weightVal != 0) {
              currWeight = weightVal;
              updatedays = i;
            }
          }
          if (updatedays == -1) {
            this.Weight2Update = "weight data out-of-date";
            this.Weight2Lose = "N/A"
          }
          else if (updatedays == 0) {
            this.Weight2Lose = Math.max(0, currWeight - this.weightGoal).toString();
            this.Weight2Update = "Updated today"
          }
          else if (updatedays == 1) {
            this.Weight2Lose = Math.max(0, currWeight - this.weightGoal).toString();
            this.Weight2Update = "Updated yesturday"
          }
          else {
            this.Weight2Lose = Math.max(0, currWeight - this.weightGoal).toString();
            this.Weight2Update = "Updated " + updatedays + " days ago"
          }
          console.log("weight stak is val " + this.weightStack)
          let axisMin = Math.min((this.weightGoal - 20), minWeight(this.weightStack) - 20)
          if (axisMin < 0) {
            axisMin = 0;
          }
  
          for (var i = 0; i < this.weightStack.length; i++) {
            if (this.weightStack[i] != 0) {
              this.weightStack[i] -= axisMin;
            }
          }
          for (var i = 0; i < this.weightStack2.length; i++) {
            if (this.weightStack2[i] != 0) {
              this.weightStack2[i] -= axisMin;
            }
          }
          while (this.weightStack3[this.weightStack3.length - 1] == 0) {
            this.weightStack3.pop()
            this.Weightlabels3.pop()
          }
          this.weightStack3 = this.weightStack3.reverse()
          this.Weightlabels3 = this.Weightlabels3.reverse()
  
          for (var i = 0; i < this.weightStack3.length; i++) {
            if (this.weightStack3[i] != 0) {
              this.weightStack3[i] -= axisMin;
            }
          }
  
          for (var i = 0; i < this.weightStack3.length; i++) {
            this.limit_line3.push(this.weightGoal - axisMin)
          }
          for (var i = 0; i < this.Weightlabels.length; i++) {
            this.limit_line[i] = this.weightGoal - axisMin;
          }
          for (var i = 0; i < this.Weightlabels2.length; i++) {
            this.limit_line2[i] = this.weightGoal - axisMin;
          }
          this.myChart = new Chart(this.ctx, {
            type: 'bar',
            data: {
              labels: this.Weightlabels,
              datasets: [{
                label: "goal",
                type: "line",
                borderColor: "rgb(255, 134, 78)",
                backgroundColor: "rgb(255, 134, 78)",
                data: this.limit_line,
                fill: false,
                borderWidth: 4,
              },
              {
                label: "weight-line",
                type: "line",
                borderColor: "rgba(52, 152, 219, 0.6)",
                backgroundColor: "rgba(52, 152, 219,0.4)",
                data: [],
                fill: false,
                borderWidth: 4,
              }
  
                , {
                label: "weight-bar",
                type: "bar",
                // borderColor: "#FFC300",
                // backgroundColor: "rgba(247, 220, 111,0.6)",
                backgroundColor: "rgba(52, 152, 219,0.4)",
                backgroundColorHover: "#3e95cd",
                data: this.weightStack
              }
              ]
            },
            options: {
              title: {
                display: false,
                text: ''
              },
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
  
                    if (label) {
                      label += ': ';
                    }
                    label += tooltipItem.yLabel + axisMin;
                    return label;
                  }
                }
              },
              scales: {
                xAxes: [{
                  stacked: false,
                  barPercentage: 0.6
                }],
                yAxes: [{
                  stacked: false,
                  ticks: {
                    suggestedMin: axisMin,
                    callback: function (value, index, values) {
                      return axisMin + value;
                    }
                  }
                }]
              },
              legend: { display: true }
            }
          });
        });
      });
      
    }

    
  }

  getDay(date: string): string {
    var res = date.split(" ");
    var day = res[1];
    res = day.split(",");
    day = res[0];
    return day;
  }

  getMonth(date: string): string {
    var res = date.split(" ");
    return res[0];
  }

  getYear(date: string): string {
    var res = date.split(" ");
    return res[3];
  }

  getToday(): Number {
    var d = new Date();
    var day = Number(d.getDate());
    return day;
  }

  toLogs() {
    this.router.navigateByUrl('/logs');
  }

  toggleWeek() {
    this.weekColor = true;
    this.monthColor = false;
    this.allColor = false;
    this.topLabel = "past week of weight data"
    // this.myChart.options.yAxes.suggestedMin=this.axisMin
    this.myChart.data.labels = this.Weightlabels
    this.myChart.data.datasets[2].data = this.weightStack
    this.myChart.data.datasets[1].data = []
    this.myChart.data.datasets[0].data = this.limit_line
    this.myChart.update();
  }

  toggleMonth() {
    this.weekColor = false;
    this.monthColor = true;
    this.allColor = false;
    // this.myChart.options.yAxes.suggestedMin=this.axisMin2
    this.topLabel = "past 2 months of weight data"
    this.myChart.data.labels = this.Weightlabels2
    this.myChart.data.datasets[2].data = this.weightStack2
    this.myChart.data.datasets[1].data = []
    this.myChart.data.datasets[0].data = this.limit_line2
    this.myChart.update();

  }

  toggleAll() {
    this.weekColor = false;
    this.monthColor = false;
    this.allColor = true;
    this.topLabel = "all time weight data"
    this.myChart.data.labels = this.Weightlabels3
    this.myChart.data.datasets[2].data = []
    this.myChart.data.datasets[1].data = this.weightStack3
    this.myChart.data.datasets[0].data = this.limit_line3
    this.myChart.update();

  }

  checkCoach(): Boolean {
    console.log("checking coach");
    if (this.cookie.get('coach') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  openFeedbackForm() {
    document.getElementById("feedbackForm").style.display = "block";
  }
  
  closeFeedbackForm() {
    document.getElementById("feedbackForm").style.display = "none";
  }

}


function formatDate(date) {

  var dd = date.getDate();
  var mm = date.getMonth() + 1;
  var yyyy = date.getFullYear();
  if (dd < 10) { dd = '0' + dd }
  if (mm < 10) { mm = '0' + mm }
  date = mm.toString() + '/' + dd.toString();
  return date
}

function Last7Days() {
  var result = [];
  for (var i = 0; i < 7; i++) {
    var d = new Date();
    d.setDate(d.getDate() - i);
    result.push(formatDate(d))
  }

  return (result);
}

function Last7Weeks() {
  var result = [];
  for (var i = 0; i < 8; i++) {
    var d = new Date();
    d.setDate(d.getDate() - i * 7);
    result.push(formatDate(d))
  }

  return (result);
}

function minWeight(weightArray) {
  var min = 100000
  for (var i = 0; i < weightArray.length; i++) {
    if (weightArray[i] < min && weightArray[i] != 0) {
      min = weightArray[i]
    }
  }
  return min;
}